import map from 'lodash/map'

import React from 'react'
import { ProductMappingFields } from '@ztechapps/product.common'
import join from 'lodash/join'

export const productFieldsData = map(Object.entries(ProductMappingFields), ([key, item]: [string, any]) => {
  if (item?.type === 'array')
    return {
      fieldName: key,
      value: (
        <div>
          Any string value with "<span className={'text-info fw-bold'}>|</span>" (pipe character) or "
          <span className={'text-info fw-bold'}>,</span>" (comma character) as delimiter
        </div>
      ),
    }

  if (item?.type === 'number') return { fieldName: key, value: 'Must be a valid number' }
  if (item?.type === 'boolean')
    return {
      fieldName: key,
      value: (
        <div>
          Must be <span className={'text-info fw-bold'}>TRUE</span> or{' '}
          <span className={'text-info fw-bold'}>FALSE</span> only. Not case sensitive
        </div>
      ),
    }

  if (item?.validValues)
    return {
      fieldName: key,
      value: (
        <div>
          Must be any of <span className={'text-info fw-bold'}>{join(item?.validValues, ', ')}</span> only
        </div>
      ),
    }

  return { fieldName: key, value: 'Any string values' }
})
